import { css } from '@emotion/react';

import { flex } from 'src/styles/utils';
import { consumptionPageUrls } from 'src/utils/constants/stringConstants';

import { colors } from '../../../../styles/colors';

export const shareModelContainer = (cssClassName: string) => css`
  position: relative;
  ${cssClassName === 'referralExitNudge'
    ? `
    position: relative;
    top: 30px;
  `
    : ``}
`;

export const container = css`
  position: absolute;
  display: flex;
  bottom: 38px;
  width: 144px;
  &:before {
    background: ${colors.PrimaryWhiteColor};
    content: '';
    height: 11px;
    left: 12px;
    bottom: -4px;
    position: absolute;
    transform: rotate(-45deg);
    width: 11px;
    box-shadow: 0px 0px 1px 1px ${colors.Grey88};
  }
`;

export const shareWrapper = css`
  ${flex('row', 'space-evenly', '')}
  background: ${colors.white};
  border-radius: 8px;
  border: 1px solid ${colors.Grey88};
  overflow: hidden;
  padding: 5px 0 4px 1px;
  position: relative;
  text-align: center;
  width: 100%;
`;

export const copyLink = css`
  cursor: pointer;
  padding: 0;
  height: 26px;
  width: 26px;
  border-radius: 50%;
  transition: background-color 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  color: ${colors.PrimaryWhiteColor};
  background: url(${consumptionPageUrls.COPY_LINK_URL})
    ${colors.AccentDarkGrayColor} no-repeat center;
  &:hover {
    background: url(${consumptionPageUrls.COPY_LINK_URL}) ${colors.PurpleBtn}
      no-repeat center;
  }
`;

export const mediaBgStyle = css`
  color: ${colors.PrimaryWhiteColor};
  padding: 2px 4px;
  height: 26px;
  width: 26px;
  border-radius: 50%;
  transition: background-color 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  background: ${colors.AccentDarkGrayColor};
  &:hover {
    background: ${colors.PurpleBtn};
  }
`;
